module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Bold-6cd35edfbc0d7a41713109d9162a0ffc.woff2";